<template>
  <div>
    <div class="chat-body" ref="chatBody">
      <div
        v-for="(msg, index) in messages"
        :key="index"
        :class="[
          'message-row',
          msg.roleType === 'SELLER' ? 'agent' : 'customer',
        ]"
      >
        <!-- <pre>{{ messages }}</pre> -->
        <div class="avatar"><i class="fa fa-user"> </i></div>
        <div class="message">{{ msg.text }}</div>
      </div>
    </div>

    <div class="chat-input">
      <input
        v-model="newMessage"
        @keyup.enter="sendMessage"
        placeholder="Write a message..."
      />
      <button @click="sendMessage">➤</button>
    </div>
  </div>
</template>

<script>
import io from "socket.io-client";
// import { NIPIGE_BASE_URL } from "@/config";
import { mapState } from "vuex";
export default {
  data() {
    return {
      loading: true,
      newMessage: "",
      messages: [],
      socket: null,
      userId: "",
      token: "",
      contextId: "", // product ID or context
      messagesId: "", // conversation ID
    };
  },
  props: {
    sellerDetails: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState({
      chatList: (state) => state.home.chatList,
    }),
  },
  methods: {
    async initialize() {
      console.log(this.sellerDetails, "INN");
      this.messages = this.sellerDetails.messages;
      this.userId = this.sellerDetails.cid._id;
      this.contextId = this.sellerDetails.contextId._id;
      this.token = localStorage.getItem(
        `${process.env.VUE_APP_TENANT}:access_token`,
      );
      this.baseUrl = process.env.VUE_APP_BASE_URL;
      this.messagesId = this.messages[0].conversationId;

      this.connectSocket();
      //   await this.getProductDetail();
      await this.setLastReadMessage();
      this.loading = false;
    },
    connectSocket() {
      this.socket = io(this.baseUrl, {
        query: `token=${this.token}`,
        path: "/notification/ws",
        transports: ["websocket"], // 'polling'- add polling for XHR
        withCredentials: true,
      });

      this.socket.on("connect", () => {
        console.log("Socket connected");
      });

      this.socket.on("new_message", (msg) => {
        console.log(msg, "MSG");
        console.log(msg.conversationId, "MSG", this.messagesId, "IDD");

        if (msg.conversationId === this.messagesId) {
          this.messages.push(msg);
          this.$nextTick(this.scrollToBottom);
          if (msg.fid !== this.userId) {
            this.socket.emit("delivered_bs_chat_message", {
              id: this.messagesId,
              messageId: msg._id,
            });
            this.socket.emit("read_bs_chat_message", {
              id: this.messagesId,
              messageId: msg._id,
            });
          }
          this.setLastReadMessage();
        }
      });

      this.socket.on("message_received", (data) => {
        console.log("Message received:", data);
      });

      this.socket.on("message_read", (data) => {
        console.log("Message read:", data);
      });
    },
    async setLastReadMessage() {
      const last = {
        id: this.messagesId,
        lastMessageId: this.messages[this.messages.length - 1]?._id || "",
      };
      let lastRead = JSON.parse(localStorage.getItem("lastReadMessage")) || [];
      const index = lastRead.findIndex((i) => i.id === last.id);

      if (index !== -1) {
        lastRead[index] = last;
      } else {
        lastRead.push(last);
      }

      localStorage.setItem("lastReadMessage", JSON.stringify(lastRead));
    },
    scrollToBottom() {
      const chatBody = this.$refs.chatBody;
      if (chatBody) {
        chatBody.scrollTop = chatBody.scrollHeight;
      }
    },
    sendMessage() {
      if (this.newMessage.trim()) {
        this.socket.emit("send_bs_new_message", {
          tid: this.userId,
          contextId: this.contextId,
          text: this.newMessage.trim(),
        });
        this.newMessage = "";
      }
    },
  },
  mounted() {
    // this.getChatList();
    this.initialize();
  },
  beforeDestroy() {
    if (this.socket) {
      this.socket.off("connect");
      this.socket.off("new_message");
      this.socket.off("message_received");
      this.socket.off("message_read");
      this.socket.disconnect();
    }
  },
};
</script>

<style scoped>
.chat-body {
  background-color: #fff;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-height: 200px;
  max-height: 250px;
  overflow-y: auto;
  padding: 10px;
}

.message-row {
  display: flex;
  align-items: flex-end;
}

.message-row.customer .message {
  background-color: #064b1f;
  color: white;
  padding: 10px 14px;
  border-radius: 0px 12px 12px 12px;
  margin-left: 10px;
  max-width: 60%;
}

.message-row.agent {
  flex-direction: row-reverse;
}

.message-row.agent .message {
  background-color: #f2f2f2;
  color: black;
  padding: 10px 14px;
  border-radius: 12px 0px 12px 12px;
  margin-right: 10px;
  max-width: 60%;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.chat-input {
  display: flex;
  padding: 10px;
  border-top: 1px solid #ccc;
}

.chat-input input {
  background-color: #dcdcdc;
  flex: 1;
  border-radius: 6px;
  outline: none;
  padding: 10px;
  margin-right: 10px;
  font-size: 14px;
  border: none;
}

.chat-input button {
  color: black;
  border: 1px solid #064b1f;
  border-radius: 26px;
  padding: 0 13px;
  font-size: 14px;
  cursor: pointer;
  background: white;
}
</style>
